var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvestIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.0498 2H10.0498V6C10.0498 8.21 8.2598 10 6.0498 10C3.8398 10 2.0498 8.21 2.0498 6V2ZM7.0498 11.92C9.8898 11.44 12.0498 8.98 12.0498 6V2V0H10.0498H2.0498H0.0498047V2V6C0.0498047 8.97 2.2098 11.44 5.0498 11.92V18H1.0498V20H11.0498V18H7.0498V11.92ZM18.9998 0L20.4098 1.41L23.9498 4.95L22.5398 6.36L19.9998 3.82V20H17.9998V3.83L15.4598 6.37L14.0498 4.95L17.5898 1.41L18.9998 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestIcon);
export default __webpack_public_path__ + "static/media/investIcon.ed780d9e9a58b355ef816a764d278599.svg";
export { ForwardRef as ReactComponent };